import {apiWithToken} from '../../../systems/api';
import {API_URL} from '../../../systems/globalContant';

export default {
    fetchLogs: (object, object_id, params = {}) => apiWithToken.get(API_URL.DEFAULT + `/logs/${object}/${object_id}`, {params, loading: false, singleRequest: true}),
    fetchOrderComments: (orderId) => apiWithToken.get(API_URL.DEFAULT + `/orders/${orderId}/comments`, {loading: false, singleRequest: true}),
    commentOrder: (orderId, data) => apiWithToken.post(API_URL.DEFAULT + `/orders/${orderId}/comments`, data, {loading: false}),
    commentComplaint: (complaintSellerId, data) => apiWithToken.post(API_URL.DEFAULT + `/complaint-seller-comments/${complaintSellerId}`, data, {loading: false}),
    commentProductReturn: (data) => apiWithToken.put(API_URL.DEFAULT + `/product-returns/${data.object_id}/add-comment`, data, {loading: false}),
}